export { default as Code } from './code';

export { default as CodeBlock } from './code-block';

export type { CodeBlockProps } from './internal/types';
export type { CodeProps } from './types';

export {
	SUPPORTED_LANGUAGES,
	type SupportedLanguages,
	type LanguageAlias,
	type Language,
} from './constants';
